import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import apiClient from '../../api/apiClient';
import { Search } from 'lucide-react';
import DevelopmentHeader from '../../components/hris/development/DevelopmentHeader';
import DevelopmentTable from '../../components/hris/development/DevelopmentTable';
import { containerVariants, itemVariants } from '../../utils/animations';

export default function EmployeeDevelopmentList() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const data = await apiClient.get('/hris/development');
      setPrograms(data.programs || []);
    } catch (error) {
      // Error loading data
    } finally {
      setLoading(false);
    }
  };

  const filteredData = programs.filter(item =>
    item.program_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <motion.div
      className="space-y-4 md:space-y-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div variants={itemVariants}>
        <DevelopmentHeader />
      </motion.div>
      <motion.div variants={itemVariants} className="bg-white rounded-lg border shadow-sm">
        <div className="p-4 border-b">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Cari program..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-300"
            />
          </div>
        </div>
        <DevelopmentTable programs={filteredData} loading={loading} />
      </motion.div>
    </motion.div>
  );
}
